module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_one-c3de7ec913ad0e7138768d7371686da2.jpg";